<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xii"></a><a id="page_xiii"></a>THE JEWISH REVOLUTION IN<br/>BELORUSSIA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?4f96b118